import React from 'react';
import './baseButton.css'; // Shared styles

/**
 * WhiteButton Component
 * Renders a reusable white-gradient button with sliding text animation.
 *
 * @param {object} props - Component props.
 * @param {string} props.width - Width of the button.
 * @param {string} props.firstText - Text shown initially.
 * @param {string} props.secondText - Text shown on hover.
 * @param {function} props.handleClick - Function to handle button click.
 */
const CustomWhiteButton = ({ width, firstText, secondText, handleClick, ...props }) => {
    return (
        <button className='base-button button-white-style' style={{ width: width }} onClick={handleClick} {...props}>
            <div className="button-text-container">
                <p className="button-text-main" style={{ color: '#000000' }}>
                    {firstText}
                </p>
                <p className="button-text-hover" style={{ color: '#000000' }}>
                    {secondText}
                </p>
            </div>
        </button>
    );
};

export default CustomWhiteButton;
